import { computed, Injectable, signal } from '@angular/core';

export type DeactivateProjectChangeActionReason = 'productionUser' | 'runningAssistant';

@Injectable({
  providedIn: 'root'
})
export class DeactivateProjectChangeActionService {
  private reasonsToDeactivateProjectChangeAction = signal<Set<DeactivateProjectChangeActionReason>>(new Set<DeactivateProjectChangeActionReason>());

  public readonly shouldDeactivateProjectChangeAction = computed(() =>
    this.reasonsToDeactivateProjectChangeAction().size > 0
  );

  public addReasonToDeactivateProjectChangeAction(reason: DeactivateProjectChangeActionReason): void {
    this.reasonsToDeactivateProjectChangeAction.update(set => new Set(set).add(reason));
  }

  public removeReasonToDeactivateProjectChangeAction(reason: DeactivateProjectChangeActionReason): void {
    this.reasonsToDeactivateProjectChangeAction.update(set => {
      const newSet = new Set(set);
      newSet.delete(reason);
      return newSet;
    });
  }

  public removeAllReasonsToDeactivateProjectChangeAction(): void {
    this.reasonsToDeactivateProjectChangeAction.update(() => new Set<DeactivateProjectChangeActionReason>());
  }
}
